//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@/0/components/comForm/comPageHeader";
import EditDropDownList from "@/0/components/comForm/comEditControls/comEditLinkedDropDownList/comEditDropDownList.vue";
import PageFooter from "@/0/components/comForm/comPageFooter2";

export default {
  props: ["onConfirmClick"],
  components: {
    "page-header": PageHeader,
    "edit-dropdownlist": EditDropDownList,
    "page-footer": PageFooter,
  },
  data() {
    return {
      
      isShow: false,
      headerConfig: {
        Title: "选择"
      },
      controlItem: {},

      ControlDataList:[],

      // ControlData:{},

      footerConfig: {
        ButtonList: [
          {
            Text: "保  存",
            Type: "primary",
            OnClick: () => {
              this._onSubmitClick();
            }
          },

          {
            Text: "取  消",
            Type: "warning",
            OnClick: () => {
              this._onCloseClick();
            }
          },
          
        ]
      },      
    };
  },
  created() {

  },

  methods: {

    initForm(controlItem) {

      this.controlItem = controlItem;
      console.log("initForm",controlItem);
      controlItem.ControlData.Index = 0;
      this.ControlDataList.splice(0,1,controlItem.ControlData);
      //this.headerConfig.Title = controlItem.LabelName;      
    },

    async onConfirmCilck(thisControlDataItem,thisDataItem) {

      console.log("onConfirmCilck===thisControlDataItem",thisControlDataItem);
      console.log("onConfirmCilck===thisDataItem",thisDataItem);

      if(!thisDataItem){
        return;        
      }

      if(!thisDataItem.IsHasChild){
        return;
      }

      this.$msg.showLoading("正在加载...");
      var url = thisDataItem.Url;
      var postData = {};
      let { data: result } = await this.$http.post(url, postData);
      console.log("getdata", result);
      this.$msg.hideLoading();
      if (result.state == 1) {
        var childControlDataItem = result.data;

        var childIndex = thisControlDataItem.Index + 1;
        childControlDataItem.Index = childIndex;
        console.log("childControlDataItem", childControlDataItem);

        this.ControlDataList.splice(childIndex,1000);
        //this.$set(this.ControlDataList,childIndex,childControlDataItem);
        this.ControlDataList.splice(childIndex,1,childControlDataItem);

        //this.ControlDataList.splice(childIndex,1,childControlDataItem);
        //this.$set(this.ControlDataList,childIndex,childControlDataItem);
        console.log("this.ControlDataList", this.ControlDataList);
        this.$msg.succ2("加载完成");
        return;
      }
    
    },


    IsShow() {
      this.isShow = !this.isShow;
    },

    Show(){
      this.isShow = true;
    },

    Hide(){
      this.isShow = false;
    },

    async _onCloseClick() {

      this.Hide();
    },

    async _onSubmitClick() {

      this.controlItem.ControlName = this.ControlDataList.map(m=>m.ControlName).join("/");
      this.controlItem.ControlValue = this.ControlDataList.map(m=>m.ControlValue).join(",");

      var controlValueList = this.ControlDataList.map(m=>{
        var dataItem = {};
        dataItem.ControlId = m.ControlId;
        dataItem.ControlValue = m.ControlValue;
        return dataItem;
      });
      
      this.controlItem.ControlValueList = controlValueList;

      this.Hide();
      this.$emit("onConfirmClick",this.controlItem);
    },
    
  }
};
